<template lang="pug">
.col-md-3.px-0.col-transition(:class="sidebarClass")
  forms-filters-tree-header-vue(v-if="!singleFilter" :headerClass="headerClass()")
  div
    forms-filters-tree-vue(
      v-if="singleFilter && singleFilterTree",
      :node="singleFilterTree",
      :opened_children="filter_nodes[0].opened_children"
      :show_header="true"
      :is_document_view="true"
      @redirect:search="redirectHubSearch"
    )
    forms-multiple-filters-tree-vue(
      v-else,
      :current_filter_id='current_hub',
      :filterNodes="filter_nodes",
      :nodes="hubsNodes"
      @redirect:search="redirectHubSearch"
    )
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "hubs-filters-vue",
  props: {
    filter_nodes: { type: Array, default: () => [] },
    current_hub: { type: String, default: () => '' }
  },
  components: {
    "forms-filters-tree-vue": () =>
      import(/* webpackChunkName: "[request]" */ "../forms/FiltersTree.vue"),
    "forms-multiple-filters-tree-vue": () =>
      import(
        /* webpackChunkName: "[request]" */ "../forms/MultipleFiltersTree.vue"
      ),
    'forms-filters-tree-header-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/forms/FiltersTreeHeader'
    ),
  },
  computed: {
    singleFilter() {
      return this.filter_nodes.length == 1
    },
    singleFilterTree(){
      return this.hubsNodes ? this.hubsNodes[0] : undefined
    },
    sidebarClass(){
      return  this.collapsePanel ? 'collapsed' : ''
    },
    ...mapState("hub_search", ["hubsNodes", "collapsePanel"]),
  },
  methods: {
    redirectHubSearch(filter_value,node){
      const baseUrl = gon.url_for.hubs_indice_path.replace(':id', node.id)

      const params = new URLSearchParams()

      if (node.ambito) {
        params.append('ambito_hub', node.ambito)
      }
      params.append('filter_hub', filter_value)
      window.location.href = `${baseUrl}?${params}`
    },
    headerClass(){
      return this.singleFilter ? `filterHeader filterHeader-${this.filter_nodes[0].ambito}` : 'multipleFilterHeader'
    },
    ...mapActions("hub_search", ["fetchHubNode"]),
  },
  mounted() {
    this.filter_nodes.forEach((filterNode) => {
      this.fetchHubNode(filterNode)
    })
  },
};
</script>